export enum IconTypeEnum {
  ITINERARIES= 'itineraries',
  WEATHER_CLEAR= 'weather_clear',
  WEATHER_CLOUDS= 'weather_clouds',
  WEATHER_RAIN= 'weather_rain',
  WEATHER_DRIZZLE= 'weather_drizzle',
  WEATHER_SNOW= 'weather_snow',
  WEATHER_THUNDERSTORM= 'weather_thunderstorm',
}